(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      if(Debutify.settings.dbtfy_sticky_header == false) return;

      this.defaultColorScheme = "dbtfy-color-"+this.dataset.colorScheme;
      this.defaultCustomColorScheme = "color-"+this.dataset.customColorScheme;
      this.transparentColorScheme = "dbtfy-color-"+this.dataset.transparentHeaderColorScheme;
      this.transparentCustomColorScheme = "color-"+this.dataset.customTransparentHeaderColorScheme;
      
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      if(Debutify.widgets.header.header_transparent && document.body.classList.contains('template-index')){
        this.classList.add('dbtfy-header--transparent');
        this.classList.add(this.transparentColorScheme);
        this.classList.add(this.transparentCustomColorScheme);
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
        
        if(Debutify.widgets.header.header_transparent && document.body.classList.contains('template-index')){
          this.classList.add(this.defaultColorScheme,this.defaultCustomColorScheme);
          if(this.classList.contains("dbtfy-header--transparent")){
            this.classList.remove('dbtfy-header--transparent');
          }
          if(this.transparentColorScheme){
            //this.classList.remove(this.transparentColorScheme);
          }
          if (this.transparentCustomColorScheme) {
            //this.classList.remove(this.transparentCustomColorScheme);
          }
        }
        
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {

        if(Debutify.widgets.header.header_transparent && document.body.classList.contains('template-index')){
          this.classList.add(this.transparentColorScheme,this.transparentCustomColorScheme,'dbtfy-header--transparent');
          if(this.defaultColorScheme){
            this.classList.remove(this.defaultColorScheme);
          }
          if (this.defaultCustomColorScheme) {
            this.classList.remove(this.defaultCustomColorScheme);
          }
        }

        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }
      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["notti-reviews"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('notti-reviews-slider')) return;

    class NottiReviewsSlider extends HTMLElement {
      connectedCallback() {
        this.startFrame = requestAnimationFrame(() => this.initialize());
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.startFrame);
        cancelAnimationFrame(this.layoutFrame);
        cancelAnimationFrame(this.scrollFrame);
        clearTimeout(this.announceTimer);
        this.events?.abort();
        this.resizeObserver?.disconnect();
        this.ready = false;
      }

      initialize() {
        if (!this.isConnected || this.ready) return;
        this.track = this.querySelector('[data-nr-track]');
        this.cards = Array.from(this.querySelectorAll('[data-nr-card]'));
        if (!this.track || !this.cards.length) return;
        this.ready = true;
        this.dots = this.querySelector('[data-nr-dots]');
        this.controls = this.querySelector('[data-nr-controls]');
        this.previous = this.querySelector('[data-nr-prev]');
        this.next = this.querySelector('[data-nr-next]');
        this.status = this.querySelector('[data-nr-status]');
        this.events = new AbortController();
        const options = { signal: this.events.signal };
        this.points = [0];
        this.activePage = 0;
        this.cards.forEach((card, index) => {
          card.setAttribute('aria-label', `Review ${index + 1} of ${this.cards.length}`);
        });

        this.previous.addEventListener('click', () => this.goToPage(this.activePage - 1), options);
        this.next.addEventListener('click', () => this.goToPage(this.activePage + 1), options);
        this.dots.addEventListener('click', (event) => {
          const button = event.target.closest('[data-nr-page]');
          if (button && this.dots.contains(button)) this.goToPage(Number(button.dataset.nrPage));
        }, options);
        this.track.addEventListener('scroll', () => {
          cancelAnimationFrame(this.scrollFrame);
          this.scrollFrame = requestAnimationFrame(() => this.update());
          clearTimeout(this.announceTimer);
          this.announceTimer = setTimeout(() => {
            if (this.points.length > 1) this.status.textContent = `Review page ${this.activePage + 1} of ${this.points.length}`;
          }, 180);
        }, { ...options, passive: true });
        this.track.addEventListener('keydown', (event) => {
          if (event.target !== this.track) return;
          let page;
          if (event.key === 'ArrowRight') page = this.activePage + (this.rtl ? -1 : 1);
          if (event.key === 'ArrowLeft') page = this.activePage + (this.rtl ? 1 : -1);
          if (event.key === 'Home') page = 0;
          if (event.key === 'End') page = this.points.length - 1;
          if (page !== undefined) { event.preventDefault(); this.goToPage(page); }
        }, options);
        document.addEventListener('shopify:block:select', (event) => {
          const selected = this.cards.find((card) => card.dataset.blockId === String(event.detail?.blockId));
          if (selected) this.scrollToPosition(this.cardOffset(selected), false);
        }, options);
        const requestLayout = () => {
          cancelAnimationFrame(this.layoutFrame);
          this.layoutFrame = requestAnimationFrame(() => this.measure());
        };
        if ('ResizeObserver' in window) {
          this.resizeObserver = new ResizeObserver(requestLayout);
          this.resizeObserver.observe(this.track);
        } else {
          window.addEventListener('resize', requestLayout, options);
        }
        this.measure();
        this.dataset.enhanced = 'true';
      }

      get position() { return Math.abs(this.track.scrollLeft); }

      cardOffset(card) {
        const first = this.cards[0].getBoundingClientRect();
        const current = card.getBoundingClientRect();
        return this.rtl ? first.right - current.right : current.left - first.left;
      }

      measure() {
        // Remove centering before measuring so a narrower viewport cannot
        // put overflowing cards at a negative, unreachable scroll offset.
        this.dataset.scrollable = 'true';
        const width = this.track.clientWidth;
        if (width < 1) return;
        const styles = getComputedStyle(this.track);
        this.rtl = styles.direction === 'rtl';
        const gap = parseFloat(styles.columnGap) || 0;
        const cardWidth = this.cards[0].getBoundingClientRect().width;
        this.maximum = Math.max(0, this.track.scrollWidth - width);
        const perPage = Math.max(1, Math.floor((width + gap + 2) / (cardWidth + gap)));
        this.points = [0];
        for (let index = perPage; index < this.cards.length; index += perPage) {
          const position = Math.min(this.maximum, Math.max(0, this.cardOffset(this.cards[index])));
          if (position - this.points[this.points.length - 1] > 2) this.points.push(position);
        }
        if (this.maximum - this.points[this.points.length - 1] > 2) this.points.push(this.maximum);
        const signature = `${this.points.length}:${perPage}`;
        if (signature !== this.dotSignature) {
          const focusIndex = this.dots.contains(document.activeElement) ? Number(document.activeElement.dataset.nrPage) : null;
          this.dots.replaceChildren();
          this.points.forEach((_, index) => {
            const button = document.createElement('button');
            button.type = 'button';
            button.className = 'nr__dot';
            button.dataset.nrPage = String(index);
            button.setAttribute('aria-label', `Go to review page ${index + 1}`);
            button.setAttribute('aria-controls', this.track.id);
            this.dots.appendChild(button);
          });
          if (focusIndex !== null) this.dots.children[Math.min(focusIndex, this.points.length - 1)]?.focus({ preventScroll: true });
          this.dotSignature = signature;
        }
        this.dataset.scrollable = String(this.maximum > 2);
        this.controls.hidden = this.points.length < 2 || (this.previous.hidden && this.dots.hidden);
        this.update();
      }

      update() {
        const current = this.position;
        let nearest = 0;
        this.points.forEach((point, index) => {
          if (Math.abs(point - current) < Math.abs(this.points[nearest] - current)) nearest = index;
        });
        this.activePage = nearest;
        this.dots.querySelectorAll('[data-nr-page]').forEach((button, index) => {
          if (index === nearest) button.setAttribute('aria-current', 'true');
          else button.removeAttribute('aria-current');
        });
        this.previous.disabled = current <= 2;
        this.next.disabled = current >= this.maximum - 2;
      }

      scrollToPosition(position, animate = true) {
        const target = Math.max(0, Math.min(this.maximum, position));
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.track.scrollTo({ left: this.rtl ? -target : target, behavior: animate && !reduceMotion ? 'smooth' : 'instant' });
      }

      goToPage(index) {
        const page = Math.max(0, Math.min(this.points.length - 1, index));
        this.scrollToPosition(this.points[page]);
      }
    }
    customElements.define('notti-reviews-slider', NottiReviewsSlider);
  })();

  } catch(e) { console.error(e); }
})();
})();
